import { twMerge } from "tailwind-merge"
const Heading4: React.FC<React.HTMLAttributes<HTMLSpanElement>> = ({ className, children, ...props }) => {
  return (
    <h4
      className={twMerge("font-bricolage font-extrabold text-3xl leading-[100%] md:leading-[130%]", className)}
      {...props}>
      {children}
    </h4>
  )
}

export default Heading4
